import { Navigate, useNavigate, useRoutes } from 'react-router-dom';
import { lazy, Suspense, useEffect } from 'react';
import { decryptText, storage } from '@/utils'
import store from '@/store';

interface IRouterMap {
    path: string,
    auth: boolean | string,
    title?: string,
    element: any,
    children? : IRouterMap[]
}

let routerMap: IRouterMap[] = []

// pages of EE
const RouterBeforeEach = lazy(() => import('@/router/RouterBeforeEach'))
const HomePage = lazy(() => import('@/views/HomePage/HomePage'))
const EELogin = lazy(() => import('@/views/eeLogin/Login'));
const EEFirstTimeLogin = lazy(() => import('@/views/FirstTimeLogin'))
const EEForgotPassword = lazy(() => import('@/views/ForgotPassword/index'))
const EEUserProfile = lazy(() => import('@/views/UserProfile'))
const EEFundPrice = lazy(() => import('@/views/FundPrice'))
const EECustomerSupport = lazy(() => import('@/views/CustomerSupport/CustomerSupport'))
const EEDetailInvestmentPlan = lazy(() => import('@/views/CustomerSupport/DetailInvestmentPlan'))
const EEDetailInvestmentPlanNew = lazy(() => import('@/views/CustomerSupport/DetailInvestmentPlan/newDetailInvestmentPlan'))
const EECSRiskProfile = lazy(() => import('@/views/CustomerSupport/RiskProfile'))
const EECSRiskProfileForm = lazy(() => import('@/views/CustomerSupport/RiskProfileForm'))
const EEDownloadCorner = lazy(() => import('@/views/CustomerSupport/DownloadCorner'))
const EEFAQ = lazy(() => import('@/views/CustomerSupport/FAQ'))
const EEFundSwitching = lazy(() => import('@/views/FundSwitching/FundSwitching'))
const EEFundSwitchingMenu = lazy(() => import("@/views/FundSwitching/FundSwitchingMenu"))
const EEFundSwitchingRequest = lazy(() => import("@/views/FundSwitching/FundSwitchingRequest"))
const EEFundSwitchingEnquiry = lazy(() => import('@/views/FundSwitching/FundSwitchingEnquiry'))
const EEFundSwitchingCancellation = lazy(() => import('@/views/FundSwitching/FundSwitchingCancellation'))
const EEAccountenquiries = lazy(() => import("@/views/AccountEnquiries/index"))
const EEAccountenquiriesBalancesummary = lazy(() => import("@/views/AccountEnquiries/Balancesummary"))
const EEAccountenquiriesBalancebyfund = lazy(() => import("@/views/AccountEnquiries/Balancebyfund"))
const EEAccountenquiriesAccountmovement = lazy(() => import("@/views/AccountEnquiries/Accountmovement"))
const EEAccountenquiriesInvestmentproportion = lazy(() => import("@/views/AccountEnquiries/Investmentproportion"))
const EEAccountenquiriesPerformance = lazy(() => import("@/views/AccountEnquiries/Performance"))
const EEAccountenquiriesFinancialstatementreport = lazy(() => import("@/views/AccountEnquiries/Financialstatementreport"))
const EEInvestmentInfo = lazy(() => import("@/views/AccountEnquiries/InvestmentInfo"))
const EEInvestmentPlan = lazy(() => import('@/views/FundSwitching/InvestmentPlan'))
const EERiskProfile = lazy(() => import('@/views/FundSwitching/RiskProfile'));
const FundNews = lazy(() => import('@/views/FundNews')) // ee和er共用
const EERiskProfileForm = lazy(() => import('@/views/FundSwitching/RiskProfileForm'))
const EEFundSwitchingOption = lazy(() => import('@/views/FundSwitching/FundSwitchingOption'))
const EENewInvestmentPlan = lazy(() => import('@/views/FundSwitching/NewInvestmentPlan'))
const EEAcknowledgeRisk = lazy(() => import('@/views/FundSwitching/AcknowledgeRisk'))
const NotFound = lazy(() => import('@/views/404'))
const DownloadFile = lazy(() => import('@/views/DownloadFile'))

// pages of ER
const ERFundFormDownload = lazy(() => import('@/views/FundFormDownload'))
const ERFundReport = lazy(() => import('@/views/FundReport'))
const ERLogin = lazy(() => import('@/views/erLogin/Login'))
const EESubmitSuccess = lazy(() => import('@/views/FundSwitching/SubmitSuccess'))
const EREmployerinformation = lazy(() => import('@/views/Employerinformation'))
const StandardReportList = lazy(() => import('@/views/StandardReportList'))
const MFA = lazy(() => import('@/views/MFA'))

const isMobile = navigator.userAgent.includes('AIA-Mobile')
function PageLoading() {
    return null
    // if (isMobile) {
    //     return null
    // }
    // return (
    //     <div className='pageload'>
    //         <img src={require('@/assets/img/logo.png')} alt="AIA LOGO" />
    //         {/* <div>Loading...</div> */}
    //     </div>
    // )
}

const EERouterMap = [
    {
        path: '/',
        auth: false,
        element: <Suspense fallback={<PageLoading />}> <RouterBeforeEach /> </Suspense>,
        children: [
            {
                path: 'homepage',
                auth: true,
                title: 'menu.homepage',
                element: <Suspense fallback={<PageLoading />}> <HomePage /> </Suspense>
            },
            {
                path: 'account-enquiries',
                auth: true,
                title: 'homePage.AccountEnquiries',
                element: <Navigate to='/account-enquiries/balanceSummary' replace={true} />
            },
            {
                path: 'account-enquiries',
                auth: true,
                title: 'homePage.AccountEnquiries',
                element: <Suspense fallback={null}> <EEAccountenquiries /></Suspense>,
                children: [
                    {
                        path: 'balanceSummary',
                        auth: true,
                        title: 'accountEnquiries.BalanceSummary',
                        element: <Suspense fallback={<PageLoading />}> <EEAccountenquiriesBalancesummary /></Suspense>
                    },
                    {
                        path: 'balancebyfund',
                        auth: true,
                        title: 'accountEnquiries.Balancebyfund',
                        element: <Suspense fallback={<PageLoading />}> <EEAccountenquiriesBalancebyfund /></Suspense>
                    },
                    {
                        path: 'accountmovement',
                        auth: true,
                        title: 'accountEnquiries.Accountmovement',
                        element: <Suspense fallback={<PageLoading />}> <EEAccountenquiriesAccountmovement /></Suspense>
                    },
                    {
                        path: 'investmentproportion',
                        auth: true,
                        title: 'accountEnquiries.Investmentproportion',
                        element: <Suspense fallback={<PageLoading />}> <EEAccountenquiriesInvestmentproportion /></Suspense>
                    },
                    {
                        path: 'performance',
                        auth: true,
                        title: 'accountEnquiries.Performance',
                        element: <Suspense fallback={<PageLoading />}> <EEAccountenquiriesPerformance /> </Suspense>
                    },
                    {
                        path: 'individualstatementofPVD',
                        auth: true,
                        title: 'accountEnquiries.IndividualstatementofPVD',
                        element: <Suspense fallback={<PageLoading />}> <EEAccountenquiriesFinancialstatementreport /> </Suspense>
                    },
                    {
                        path: 'investmentInfo',
                        auth: true,
                        title: 'accountEnquiries.investmentInfo',
                        element: <Suspense fallback={<PageLoading />}> <EEInvestmentInfo /> </Suspense>
                    },
                ]
            },
            {
                path: 'fund-price',
                auth: true,
                title: 'menu.fundPrice',
                element: <Suspense fallback={<PageLoading />}> <EEFundPrice /> </Suspense>
            },
            {
                path: 'fund-switching',
                auth: true,
                title: 'fundSwitchingMenu.menuTitle',
                element: <Navigate to='/fund-switching/fund-switching-menu' replace={true} />
            },
            {
                path: 'fund-switching',
                auth: true,
                title: 'fundSwitchingMenu.menuTitle',
                element: <Suspense fallback={null}> <EEFundSwitching /></Suspense>,
                children: [
                    {
                        path: 'fund-switching-menu',
                        auth: true,
                        title: 'fundSwitchingMenu.menuTitle',
                        element: <Suspense fallback={<PageLoading />}> <EEFundSwitchingMenu /></Suspense>
                    },
                    {
                        path: 'fund-switching-request',
                        auth: true,
                        title: 'fundSwitchingRequest.menuTitle',
                        element: <Suspense fallback={<PageLoading />}> <EEFundSwitchingRequest /></Suspense>
                    },
                    {
                        path: 'fund-switching-enquiry',
                        auth: true,
                        title: 'fundSwitchingEnquiry.title',
                        element: <Suspense fallback={<PageLoading />}> <EEFundSwitchingEnquiry /></Suspense>
                    },
                    {
                        path: 'fund-switching-cancellation',
                        auth: true,
                        title: 'fundSwitchingCancellation.title',
                        element: <Suspense fallback={<PageLoading />}> <EEFundSwitchingCancellation /></Suspense>
                    },
                    {
                        path: 'investment-plan',
                        auth: true,
                        title: 'investmentPlan.title',
                        element: <Suspense fallback={<PageLoading />}><EEInvestmentPlan /></Suspense>
                    },
                    {
                        path: 'risk-profile',
                        auth: true,
                        title: 'riskProfile.title',
                        element: <Suspense fallback={<PageLoading />}><EERiskProfile /></Suspense>
                    },
                    {
                        path: 'risk-profile-form',
                        auth: true,
                        title: 'riskProfileForm.title',
                        element: <Suspense fallback={<PageLoading />}><EERiskProfileForm /></Suspense>
                    },
                    {
                        path: 'fund-switching-option',
                        auth: true,
                        title: 'fundSwitchingOption.title',
                        element: <Suspense fallback={<PageLoading />}><EEFundSwitchingOption /></Suspense>
                    },
                    {
                        path: 'new-investment-plan',
                        auth: true,
                        title: 'newInvestmentPlan.title',
                        element: <Suspense fallback={<PageLoading />}><EENewInvestmentPlan /></Suspense>
                    },
                    {
                        path: 'acknowledge-risk',
                        auth: true,
                        title: 'fundSwitchingMenu.menuTitle',
                        element: <Suspense fallback={<PageLoading />}><EEAcknowledgeRisk /></Suspense>
                    },
                    {
                        path: 'submit-success',
                        auth: true,
                        title: 'submitSuccess.title',
                        element: <Suspense fallback={<PageLoading />}><EESubmitSuccess /></Suspense>
                    }
                ]
            },
            {
                path: 'customer-support',
                auth: true,
                title: 'customerSupport.title',
                element: <Navigate to='/customer-support/detail-investment-plan' replace={true} />
            },
            {
                path: 'customer-support',
                auth: true,
                title: 'customerSupport.title',
                element: <Suspense fallback={null}> <EECustomerSupport /></Suspense>,
                children: [
                    {
                        path: 'detail-investment-plan',
                        auth: true,
                        title: 'customerSupport.menuTitle1',
                        element: <Suspense fallback={<PageLoading />}> <EEDetailInvestmentPlan /></Suspense>
                    },
                    {
                        path: 'detail-investment-plan-new',
                        auth: true,
                        title: 'customerSupport.menuTitle1',
                        element: <Suspense fallback={<PageLoading />}> <EEDetailInvestmentPlanNew /></Suspense>
                    },
                    {
                        path: 'risk-profile',
                        auth: true,
                        title: 'customerSupport.menuTitle2',
                        element: <Suspense fallback={<PageLoading />}> <EECSRiskProfile /></Suspense>
                    },
                    {
                        path: 'risk-profile-form',
                        auth: true,
                        title: 'customerSupport.menuTitle2',
                        element: <Suspense fallback={<PageLoading />}> <EECSRiskProfileForm /></Suspense>
                    },
                    {
                        path: 'download-corner',
                        auth: true,
                        title: 'customerSupport.menuTitle3',
                        element: <Suspense fallback={<PageLoading />}> <EEDownloadCorner /></Suspense>
                    },
                    {
                        path: 'FAQ',
                        auth: true,
                        title: 'customerSupport.menuTitle4',
                        element: <Suspense fallback={<PageLoading />}> <EEFAQ /></Suspense>
                    },
                    {
                        path: 'user-profile',
                        auth: true,
                        title: 'customerSupport.menuTitle5',
                        element: <Suspense fallback={<PageLoading />}> <EEUserProfile /> </Suspense>
                    },
                ]
            },
            {
                path: 'provident-fund-news',
                auth: true,
                title: 'menu.fundNews',
                element: <Suspense fallback={<PageLoading />}> <FundNews /> </Suspense>
            },
            {
                path: 'user-profile',
                auth: true,
                title: 'customerSupport.menuTitle5',
                element: <Suspense fallback={<PageLoading />}> <EEUserProfile /> </Suspense>
            },
            {
                path: 'download-file',
                auth: true,
                title: 'global.downloadFile',
                element: <Suspense fallback={<PageLoading />}> <DownloadFile /> </Suspense>
            },
            {
                path: 'employer-information',
                auth: true,
                title: 'homePage.Employerinformation',
                element: <Navigate to='/employer-information/user-profile' replace={true} />
            },
            {
                path: 'employer-information',
                auth: true,
                title: 'homePage.Employerinformation',
                element: <Suspense fallback={<PageLoading />}> <EREmployerinformation /></Suspense>,
                children: [
                    {
                        path: 'user-profile',
                        auth: true,
                        title: 'customerSupport.menuTitle5',
                        element: <Suspense fallback={<PageLoading />}> <EEUserProfile /> </Suspense>
                    },
                    {
                        path: 'performance',
                        auth: true,
                        title: 'accountEnquiries.Performance',
                        element: <Suspense fallback={<PageLoading />}> <EEAccountenquiriesPerformance /> </Suspense>
                    },
                ]
            },
            {
                path: 'provident-fund-form-download',
                auth: true,
                title: 'menu.fundForm',
                element: <Suspense fallback={<PageLoading />}> <ERFundFormDownload /> </Suspense>
            },
            {
                path: 'provident-fund-report',
                auth: true,
                title: 'menu.fundReport',
                element: <Suspense fallback={<PageLoading />}> <ERFundReport /> </Suspense>
            }
        ]
    },
    {
        path: '/eelogin',
        title: 'login.login',
        auth: false,
        element: <Suspense fallback={<PageLoading />}> <EELogin /> </Suspense>
    },
    {
        path: '/mpf/ee/eelogon.jsp',
        title: 'login.login',
        auth: false,
        element: <Suspense fallback={<PageLoading />}> <EELogin /> </Suspense>
    },
    {
        path: '/erlogin',
        title: 'login.login',
        auth: false,
        element: <Suspense fallback={<PageLoading />}> <ERLogin /> </Suspense>
    },
    {
        path: '/mpf/er/erlogon.jsp',
        title: 'login.login',
        auth: false,
        element: <Suspense fallback={<PageLoading />}> <ERLogin /> </Suspense>
    },
    {
        path: 'first-time-login',
        auth: false,
        title: 'login.FirstTimeLogin',
        element: <Suspense fallback={<PageLoading />}> <EEFirstTimeLogin /> </Suspense>
    },
    {
        path: 'forgot-password',
        auth: false,
        title: 'login.ForgetPassword',
        element: <Suspense fallback={<PageLoading />}> <EEForgotPassword /> </Suspense>
    },
    {
        path: 'standard-report',
        auth: false,
        title: 'standardReport.eeTitle',
        element: <Suspense fallback={<PageLoading />}> <StandardReportList /> </Suspense>
    },
    {
        path: 'mfa',
        auth: false,
        title: 'firstTimeLogin.mfaTitle',
        element: <Suspense fallback={<PageLoading />}> <MFA /> </Suspense>
    },
    {
        path: '*',
        auth: false,
        title: '404 NOT FOUND',
        element: <Suspense fallback={<PageLoading />}> <NotFound /> </Suspense>
    }
]

const ERRouterMap: IRouterMap[] = [
    {
        path: '/',
        auth: false,
        element: <Suspense fallback={<PageLoading />}> <RouterBeforeEach/> </Suspense>,
        children: [
            // 暂时先用EE的homepage代替
            {
                path: 'homepage',
                auth: true,
                title: 'menu.homepage',
                element: <Suspense fallback={<PageLoading />}> <HomePage/> </Suspense>
            },
            {
                path: 'provident-fund-news',
                auth: true,
                title: 'menu.fundNews',
                element: <Suspense fallback={<PageLoading />}> <FundNews /> </Suspense>
            },
            {
                path: 'provident-fund-form-download',
                auth: true,
                title: 'menu.fundForm',
                element: <Suspense fallback={<PageLoading />}> <ERFundFormDownload /> </Suspense>
            },
            {
                path: 'provident-fund-report',
                auth: true,
                title: 'menu.fundReport',
                element: <Suspense fallback={<PageLoading />}> <ERFundReport /> </Suspense>
            },
            {
                path: 'user-profile',
                auth: true,
                title: 'customerSupport.menuTitle5',
                element: <Suspense fallback={<PageLoading />}> <EEUserProfile /> </Suspense>
            },
            {
                path: 'employer-information',
                auth: true,
                title: 'homePage.Employerinformation',
                element: <Navigate to='/employer-information/user-profile' replace={true} />
            },
            {
                path: 'employer-information',
                auth: true,
                title: 'homePage.Employerinformation',
                element: <Suspense fallback={<PageLoading />}> <EREmployerinformation /></Suspense>,
                children: [
                    {
                        path: 'user-profile',
                        auth: true,
                        title: 'customerSupport.menuTitle5',
                        element: <Suspense fallback={<PageLoading />}> <EEUserProfile /> </Suspense>
                    },
                    {
                        path: 'performance',
                        auth: true,
                        title: 'accountEnquiries.Performance',
                        element: <Suspense fallback={<PageLoading />}> <EEAccountenquiriesPerformance /> </Suspense>
                    },
                ]
            },
            {
                path: 'download-file',
                auth: true,
                title: 'global.downloadFile',
                element: <Suspense fallback={<PageLoading />}> <DownloadFile /> </Suspense>
            }
        ]
    },
    {
        path: '/erlogin',
        title: 'login.login',
        auth: false,
        element: <Suspense fallback={<PageLoading />}> <ERLogin /> </Suspense>
    },
    {
        path: '/mpf/er/erlogon.jsp',
        title: 'login.login',
        auth: false,
        element: <Suspense fallback={<PageLoading />}> <ERLogin /> </Suspense>
    },
    {
        path: '/eelogin',
        title: 'login.login',
        auth: false,
        element: <Suspense fallback={<PageLoading />}> <EELogin /> </Suspense>
    },
    {
        path: '/mpf/ee/eelogon.jsp',
        title: 'login.login',
        auth: false,
        element: <Suspense fallback={<PageLoading />}> <EELogin /> </Suspense>
    },
    {
        path: 'first-time-login',
        auth: false,
        title: 'login.FirstTimeLogin',
        element: <Suspense fallback={<PageLoading />}> <EEFirstTimeLogin /> </Suspense>
    },
    {
        path: 'forgot-password',
        auth: false,
        title: 'login.ForgetPassword',
        element: <Suspense fallback={<PageLoading />}> <EEForgotPassword /> </Suspense>
    },
    {
        path: 'standard-report',
        auth: false,
        title: 'standardReport.erTitle',
        element: <Suspense fallback={<PageLoading />}> <StandardReportList /> </Suspense>
    },
    {
        path: 'mfa',
        auth: false,
        title: 'firstTimeLogin.mfaTitle',
        element: <Suspense fallback={<PageLoading />}> <MFA /> </Suspense>
    },
    {
        path: '*',
        auth: false,
        title: '404 NOT FOUND',
        element: <Suspense fallback={<PageLoading />}> <NotFound /> </Suspense>
    }

]

store.subscribe(() => {
    const userType = decryptText('irpas_userType')
    // alert('userType: ' + userType)

    if (userType === 'ee') {
        routerMap = EERouterMap
    } else if (userType === 'er') {
        routerMap = ERRouterMap
    } else {
        routerMap = EERouterMap
    }
})


const checkAuth = (routers: any, path: String) => {
    for (const data of routers) {
        if (data.path === path) {
            return data;
        }
        if (data.children) {
            const res: any = checkAuth(data.children, path)
            if (res) return res;
        }
    }
    return null;
}

const checkRouterAuth = (path: String) => {
    let auth = null;
    auth = checkAuth(routerMap, path)
    return auth;
}

const Router = () => useRoutes(routerMap)


export { Router, checkRouterAuth };
